<article class="hero-carousel-static">
  <a
    [href]="slide.url"
    (click)="onSlideClick(slide, 0, $event)"
    class="hero-carousel-static__link"
    [attr.aria-label]="'Ver oferta: ' + slide.alt"
  >
    <figure class="hero-carousel-static__figure">
      <img
        [ngSrc]="stateService.getCurrentSlideImage(slide)"
        [alt]="slide.alt || 'Producto destacado'"
        fill
        sizes="100vw"
        priority
        fetchpriority="high"
        decoding="sync"
        class="hero-carousel-static__image"
        itemProp="image"
        crossorigin="anonymous"
      />

      @if (slide.title) {
      <figcaption class="sr-only" itemProp="name">
        {{ slide.title }}
      </figcaption>
      }
    </figure>
  </a>

  <!-- Static indicators -->
  <div class="hero-carousel-static__indicators" aria-hidden="true">
    @for (slideItem of allSlides; track slideItem.index) {
    <div
      class="hero-carousel-static__indicator"
      [class.hero-carousel-static__indicator--active]="$index === 0"
    ></div>
    }
  </div>
</article>
